<template>
  <!-- SectionContainer do app: bloco com título (text-header) e a divisória de ponta a ponta embaixo.
       A margem lateral vem de --app-section-gutter (no painel lateral, o padding dele). -->
  <section class="app-section">
    <div v-if="title || $slots.icon" class="d-flex align-items-center gap-2 app-section-title">
      <slot name="icon" />
      <p class="text-header m-0">{{ title }}</p>
    </div>
    <slot />
  </section>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ title?: string }>(), { title: "" });
</script>

<style scoped lang="scss">
@import "@/assets/theme/scss/user-variables";

.app-section {
  margin: 0 calc(-1 * var(--app-section-gutter, 0px));
  padding: 20px var(--app-section-gutter, 0px);
  border-bottom: 1px solid $primary10;
}

.app-section-title {
  margin-bottom: 10px;
}
</style>
